export default {
	add: 'إضافة قسم',
	edit: 'تعديل قسم',
	delete: 'حذف القسم',
	'please-select-a-section': 'اختر قسم رجاءً',

	inputs: {
		'section-name': 'اسم القسم',
		'section-parent': 'القسم الأب',
	},
	'delete-message-section': 'هل أنت متأكد من أنك تريد حذف هذا القسم ؟'
};
